import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { fetchTradeAction } from '../../ducks/sales.duck';
import { TradeActions } from '../../interfaces';

type TradeActionEvent =
  | React.MouseEvent<HTMLButtonElement>
  | React.KeyboardEvent<HTMLButtonElement>;

export const useSellingControllers = () => {
  const dispatch = useDispatch();

  const handleTradeAction = useCallback(
    (id: number, tradeAction: TradeActions) => (ev: TradeActionEvent) => {
      ev.stopPropagation();
      dispatch(fetchTradeAction(id, tradeAction));
    },
    [dispatch]
  );

  return {
    handleTradeAction,
  };
};
